import { isTextOverflowTruncate } from '../../core/components/annotations/components/canvas/utils/is-text-overflow-truncate.js';
import {
  DEFAULT_TEXT_OVERFLOW,
  DEFAULT_TRUNCATION_MODE,
} from '../../core/components/annotations/constants.js';
import {
  TextOverflowExpandOptions,
  TextOverflowTruncateOptions,
} from '../../core/components/annotations/types/marker.js';
import { AnnotationsChartConfigProperties } from '../types/annotations-chart-config-props.js';
import { AnnotationsChartProps } from '../types/annotations-chart-props.js';

/**
 * Build configuration for text overflow props
 *
 * @param props -
 * @param config -
 */
export const buildTextOverflowConfig = (
  props: AnnotationsChartProps,
  config: AnnotationsChartConfigProperties,
): TextOverflowExpandOptions | TextOverflowTruncateOptions => {
  const textOverflow =
    props.textOverflow ?? config?.textOverflow ?? DEFAULT_TEXT_OVERFLOW;

  if (textOverflow === 'truncate') {
    const truncateMode =
      isTextOverflowTruncate(props) && props.truncateMode
        ? props.truncateMode
        : isTextOverflowTruncate(config) && config.truncateMode
        ? config.truncateMode
        : DEFAULT_TRUNCATION_MODE;

    return {
      textOverflow,
      truncateMode,
    };
  }

  return { textOverflow };
};
